import React from 'react';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { ShieldAlert } from 'lucide-react';

interface PIIWarningDialogProps {
  open: boolean;
  detectedTypes: string[];
  redactedPreview: string;
  allowPostAnyway: boolean;
  onEdit: () => void;
  onPostRedacted: () => void;
  onPostAnyway: () => void;
}

const PIIWarningDialog: React.FC<PIIWarningDialogProps> = ({
  open,
  detectedTypes,
  redactedPreview,
  allowPostAnyway,
  onEdit,
  onPostRedacted,
  onPostAnyway,
}) => {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2 text-destructive">
            <ShieldAlert size={20} />
            Personal Information Detected
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3">
              <p>
                For your safety, we detected the following in your post:
              </p>
              <ul className="list-disc pl-5 space-y-1">
                {detectedTypes.map((type) => (
                  <li key={type} className="font-medium text-foreground">{type}</li>
                ))}
              </ul>
              <div className="rounded-md bg-muted p-3 text-sm">
                <p className="text-xs text-muted-foreground mb-1 font-medium">Redacted preview:</p>
                <p className="text-foreground">{redactedPreview}</p>
              </div>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col gap-2 sm:flex-col">
          <Button variant="default" onClick={onPostRedacted} className="w-full">
            Post with Redaction
          </Button>
          <Button variant="outline" onClick={onEdit} className="w-full">
            Edit My Post
          </Button>
          {allowPostAnyway && (
            <Button variant="ghost" onClick={onPostAnyway} className="w-full text-muted-foreground text-xs">
              Post Anyway
            </Button>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default PIIWarningDialog;
